module.exports = __webpack_public_path__ + "img/stock6.ed20a128.png";